// THIS FILE IS AUTO-GENERATED — do not edit by hand.
// Re-generate with: yarn workspace @portal/rocket-api-client generate:maps

export const INVALIDATION_TEMPLATE_MAP: Record<string, [string][]> = {
  createPartnerSite: [['/v1/sites']],
  suspendPartnerSite: [['/v1/sites/{id}'], ['/v1/sites']],
  unsuspendPartnerSite: [['/v1/sites/{id}'], ['/v1/sites']],
  cancelAccount: [['/v1/account/hosting_plan'], ['/v1/account/me']],
  createAccountHostingPlan: [['/v1/account/hosting_plan']],
  updateAccountHostingPlan: [['/v1/account/hosting_plan']],
  deleteAccountInvite: [['/v1/account/invites']],
  modifyAccountMe: [['/v1/account/me']],
  switchAccount: [['/v1/accounts']],
  createBillingAddress: [['/v1/billing/addresses']],
  modifyBillingAddress: [['/v1/billing/addresses/{address_id}'], ['/v1/billing/addresses']],
  deleteBillingAddress: [['/v1/billing/addresses/{address_id}'], ['/v1/billing/addresses']],
  payBillingInvoiceCreditCardPayment: [
    ['/v1/billing/invoices/{invoice_id}'],
    ['/v1/billing/invoices'],
    ['/v1/billing/payment_methods'],
  ],
  createBillingInvoicePaypalSubscription: [
    ['/v1/billing/invoices/{invoice_id}'],
    ['/v1/billing/invoices'],
  ],
  confirmBillingInvoicePaypalSubscription: [
    ['/v1/billing/invoices/{invoice_id}'],
    ['/v1/billing/invoices'],
    ['/v1/account/me'],
  ],
  createBillingPaymentMethod: [['/v1/billing/payment_methods']],
  createBillingPaymentMethodCreditCardSetupIntent: [['/v1/billing/payment_methods']],
  modifyBillingPaymentMethod: [
    ['/v1/billing/payment_methods/{payment_method_id}'],
    ['/v1/billing/payment_methods'],
  ],
  deleteBillingPaymentMethod: [
    ['/v1/billing/payment_methods/{payment_method_id}'],
    ['/v1/billing/payment_methods'],
  ],
  createSiteTemplate: [['/v1/account/me']],
  createSite: [['/v1/sites'], ['/v1/account/me']],
  createSiteTemplateDeprecated: [['/v1/sites/templates']],
  deleteSiteTemplate: [['/v1/sites/templates/{template_id}'], ['/v1/sites/templates']],
  createSiteTemplateSite: [['/v1/account/me']],
  createSiteUser: [['/v1/sites/users']],
  modifySiteUser: [['/v1/sites/users']],
  modifySite: [['/v1/sites/{id}'], ['/v1/sites']],
  deleteSite: [['/v1/sites/{id}'], ['/v1/sites']],
  disableSiteActivity: [['/v1/sites/{id}/settings']],
  enableSiteActivity: [['/v1/sites/{id}/settings']],
  createSiteActivityEvent: [['/v1/sites/{id}/activity/events']],
  deleteSiteActivityEvent: [
    ['/v1/sites/{id}/activity/events/{event_id}'],
    ['/v1/sites/{id}/activity/events'],
  ],
  createSiteBackupDeprecated: [['/v1/sites/{id}/backup']],
  restoreAutomatedSiteBackup: [['/v1/sites/{id}/backup/automated']],
  restoreAutomatedSiteBackupDatabase: [['/v1/sites/{id}/backup/automated'], ['/v1/account/me']],
  restoreAutomatedSiteBackupFiles: [['/v1/sites/{id}/backup/automated'], ['/v1/account/me']],
  deleteSiteBackupDeprecated: [['/v1/sites/{id}/backup/{backup_id}'], ['/v1/sites/{id}/backup']],
  restoreSiteBackupDeprecated: [['/v1/sites/{id}/backup/{backup_id}'], ['/v1/sites/{id}/backup']],
  cloneSite: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  createSiteCloudBackup: [['/v1/sites/{id}/cloud_backups'], ['/v1/account/me']],
  deleteSiteCloudBackup: [
    ['/v1/sites/{id}/cloud_backups/{backup_id}'],
    ['/v1/sites/{id}/cloud_backups'],
  ],
  restoreSiteCloudBackup: [
    ['/v1/sites/{id}/cloud_backups/{backup_id}'],
    ['/v1/sites/{id}/cloud_backups'],
    ['/v1/account/me'],
  ],
  createSiteDomain: [['/v1/sites/{id}/domains']],
  deleteSiteDomain: [['/v1/sites/{id}/domains']],
  modifySiteDomainEdgeSettings: [['/v1/sites/{id}/domains/{domain_id}/edge_settings']],
  createSiteFile: [['/v1/sites/{id}/files'], ['/v1/sites/{id}/file_manager/files']],
  updateSiteFile: [
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
    ['/v1/sites/{id}/files/view'],
  ],
  deleteSiteFile: [['/v1/sites/{id}/files'], ['/v1/sites/{id}/file_manager/files']],
  chmodSiteFile: [['/v1/sites/{id}/files'], ['/v1/sites/{id}/file_manager/files']],
  createSiteFilesArchive: [['/v1/sites/{id}/files'], ['/v1/sites/{id}/file_manager/files']],
  extractSiteFile: [['/v1/sites/{id}/files'], ['/v1/sites/{id}/file_manager/files']],
  createSiteFileFolder: [['/v1/sites/{id}/files'], ['/v1/sites/{id}/file_manager/files']],
  createSiteFtpAccount: [['/v1/sites/{id}/ftp/accounts']],
  modifySiteFtpAccount: [['/v1/sites/{id}/ftp/accounts']],
  deleteSiteFtpAccount: [['/v1/sites/{id}/ftp/accounts']],
  lockSite: [['/v1/sites/{id}'], ['/v1/sites']],
  unlockSite: [['/v1/sites/{id}'], ['/v1/sites']],
  createSiteMaindomain: [['/v1/sites/{id}/maindomain'], ['/v1/sites/{id}'], ['/v1/sites']],
  updateSiteMaindomain: [['/v1/sites/{id}/maindomain'], ['/v1/sites/{id}'], ['/v1/sites']],
  modifySiteMaindomain: [['/v1/sites/{id}/maindomain'], ['/v1/sites/{id}']],
  modifySiteMaindomainEdgeSettings: [['/v1/sites/{id}/maindomain/edge_settings']],
  switchSiteMaindomainPrefix: [['/v1/sites/{id}/maindomain']],
  enableSitePasswordProtection: [['/v1/sites/{id}/password_protection']],
  disableSitePasswordProtection: [['/v1/sites/{id}/password_protection']],
  createSitePasswordProtectionUser: [['/v1/sites/{id}/password_protection/users']],
  deleteSitePasswordProtectionUser: [['/v1/sites/{id}/password_protection/users']],
  installSitePlugin: [
    ['/v1/sites/{id}/plugins'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
    ['/v1/sites/{id}/featured_plugins'],
  ],
  updateSitePlugin: [
    ['/v1/sites/{id}/plugins'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
  ],
  togglePluginStatus: [
    ['/v1/sites/{id}/plugins'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
  ],
  deleteSitePlugin: [
    ['/v1/sites/{id}/plugins'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
    ['/v1/sites/{id}/featured_plugins'],
  ],
  installSiteCdnCacheManagementPlugin: [
    ['/v1/sites/{id}/plugins'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
  ],
  modifySiteSettings: [['/v1/sites/{id}/settings']],
  enableSiteShopShield: [['/v1/sites/{id}/shop_shield']],
  disableSiteShopShield: [['/v1/sites/{id}/shop_shield/{uri_id}'], ['/v1/sites/{id}/shop_shield']],
  createSiteSshKey: [['/v1/sites/{id}/ssh/keys']],
  deleteSiteSshKey: [['/v1/sites/{id}/ssh/keys']],
  authorizeSiteSshKey: [['/v1/sites/{id}/ssh/keys']],
  deauthorizeSiteSshKey: [['/v1/sites/{id}/ssh/keys']],
  createSiteSslCertificate: [['/v1/sites/{id}/ssl/certificates']],
  deleteSiteSslCertificate: [
    ['/v1/sites/{id}/ssl/certificates/{certificate_id}'],
    ['/v1/sites/{id}/ssl/certificates'],
  ],
  createSiteStaging: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  deleteSiteStaging: [['/v1/sites/{id}'], ['/v1/sites']],
  publishSiteStaging: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  cancelSiteTask: [['/v1/sites/{id}/tasks']],
  installSiteTheme: [
    ['/v1/sites/{id}/themes'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
  ],
  updateSiteTheme: [['/v1/sites/{id}/themes']],
  toggleSiteTheme: [['/v1/sites/{id}/themes']],
  deleteSiteTheme: [
    ['/v1/sites/{id}/themes'],
    ['/v1/sites/{id}/files'],
    ['/v1/sites/{id}/file_manager/files'],
  ],
  transferSite: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  acceptSiteTransfer: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  cancelSiteTransfer: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  rejectSiteTransfer: [['/v1/sites/{id}'], ['/v1/sites'], ['/v1/account/me']],
  inviteSiteUser: [['/v1/sites/{id}/users']],
  acceptSiteUserInviteForSite: [
    ['/v1/sites/{id}/users/accept'],
    ['/v1/sites/{id}/users'],
    ['/v1/sites/users'],
  ],
  deleteSiteUser: [['/v1/sites/{id}/users'], ['/v1/sites/{id}']],
  reinviteSiteUser: [['/v1/sites/{id}/users']],
  createAccountUser: [['/v1/users'], ['/v1/account/invites']],
  modifyAccountUser: [['/v1/users/{user_id}'], ['/v1/users']],
  deleteAccountUser: [['/v1/users/{user_id}'], ['/v1/users']],
  setAccountUserPassword: [['/v1/account/me']],
  reinviteAccountUser: [['/v1/users/{user_id}'], ['/v1/users'], ['/v1/account/invites']],
};
